(function ($) {
    $(document).ready(function() {
         // Acceso a cada una de las tabs de Research Programmes y Young Scientists

        if (window.location.hash.trim() != ""){

            var hash = window.location.hash.replace("#","");
            if ($('#' + hash).length){
                $('#irbTabContent > .tab-pane').removeClass('active');
                $('.pane-0').removeClass('active');
                $('.tabpane-1').removeClass('active');

                const element = document.querySelector('#irbTab')
                const topPos = element.getBoundingClientRect().top + window.scrollY
                window.scrollTo({
                    top: topPos, // scroll so that the element is at the top of the view
                    behavior: 'smooth' // smooth scroll
                })

                if ($('#' + hash).find('#irbTab > li > .' + hash)) {
                    $('#irbTab > li > .' + hash).addClass('active');
                    $('#irbTabContent > .' + hash).addClass('active');
                    $('#irbTabContent > .' + hash).addClass('show');
                }

                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        }
    });
})(jQuery, Drupal);
